module.exports = __webpack_public_path__ + "static/media/visualResized.aded3ec1.png";